export const EqualProminenceMobileSites = [
  'AU',
  'CA',
  'ES',
  'OPES',
  'CA',
  'FR',
  'GB',
  'IT',
  'OPIT',
  'PT',
  'UK',
  'US',
  'GOFR',
  'OPGB',
  'OPFR',
  'OPUK',
];

export const isEqualProminenceMobileBySite = (site: string): boolean =>
  EqualProminenceMobileSites.includes(site);
